.container {
    padding: 15px 5px;
}

.title {
    font-family: Hanken Grotesk;
    font-size: 15px;
    color: #243a5c;
}

.value {
    font-family: LustTextMedium;
    font-style: italic;
    font-size: 20px;
    color: #243a5c;
}
